export default "__VITE_ASSET__C$lNceyn__"